/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { greenApiWebhookInstanceDataSchema } from "./greenApiWebhookInstanceDataSchema.ts";

export const greenApiWebhookInstanceDataRequestSchema = greenApiWebhookInstanceDataSchema;
